<script>
  import Icon from '../Icon.svelte';

  export let text;
</script>

<style>
  .km-funfact {
    background: #f3f3f3;
    margin: 10px 0;
    font-size: 13px;
    padding: 10px;
    display: flex;
    border-radius: 4px !important;
  }

  .km-funfact :global(.km-icon) {
    margin-right: 5px;
  }
</style>

<div class="km-funfact">
  <Icon name="info" />
  <div>{text}</div>
</div>
